import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Product, UserIdService} from '@spartacus/core';
import { Subscription } from 'rxjs';
import { UigActiveCartService } from 'src/app/services/uig-active-cart.service';
import {CartItemComponent, CartItemContextSource} from '@spartacus/cart/base/components';
import {MultiCartService} from '@spartacus/cart/base/core';
import {CartItemContext} from '@spartacus/cart/base/root';

@Component({
    selector: 'app-uig-cart-item',
    templateUrl: './uig-cart-item.component.html',
    providers: [
        CartItemContextSource,
        { provide: CartItemContext, useExisting: CartItemContextSource }
    ],
    styleUrls: ['./uig-cart-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigCartItemComponent extends CartItemComponent implements OnInit, OnDestroy {

  /**
   * The UigCartItemComponent supports 2 types of styling:
   *   - One that shows the notes / notiz component;
   *   - And one that shadows it.
   * Use this flag to switch between the 2 types of styling.
   */
   @Input() public showNotes?: boolean = true;
   @Input() public cartId: string;
   @Input() public hideDeleteButton?: boolean = false;
   @Input() public savedCarts?: boolean;
   @Input() public hideBulkyGoods?: boolean = false;
   userId: string;
   userSubscription: Subscription;

   constructor(

     protected uigActiveCartService: UigActiveCartService,
     protected multiCartService: MultiCartService,
     protected userIdService: UserIdService, cartItemContextSource: CartItemContextSource) {
    super( cartItemContextSource);

  }

  ngOnInit(): void {
    this.userSubscription = this.userIdService
    ?.getUserId()
    .subscribe((userId) => (this.userId = userId));
  }

  removeItem() {
    if(this.savedCarts == true)
    {
      this.multiCartService.removeEntry(this.userId, this.cartId, this.item.entryNumber);
    } else {
      this.uigActiveCartService.removeEntry(this.item);
    }
   this.quantityControl.setValue(0,{ emitEvent: false });
   this.quantityControl.markAsDirty();
 }

 getTranslateOptions(product: Product)  {
     return {
       deliveryCostBulkyDirect: product.deliveryCostBulkyDirect?.formattedValue
     }
 }

 ngOnDestroy(): void {
  this.userSubscription.unsubscribe();
}

}
